import React, { useState } from "react";

import styles from "./dashboard.module.scss";
import map from "./asserts/mapbutton.png";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import CloseIcon from "@mui/icons-material/Close";
import IndiaMap from "./India"; // Adjust the path to where Ind
import Image89 from "./image 89.png";
import Image95 from "./image 95.png";
import Image78 from "./image 78.png";
import { useNavigate } from "react-router-dom";

const Dashboardnew = () => {
  const [tags, setTags] = useState([
    {
      id: 1,
      tag: "P23-ywn-46fer-78912",
      type: "DEBIT",
      account: "54323456",
      createdTime: "15-12-2024 13:45",
      tagValidity: "15-12-2024 15:45",
      movement: 6, // 1 day, 1 minute, 1 second
      withdrawalTried: "4",
      status: "Active",
      amount: "₹2,00,000",
    },
    {
      id: 2,
      tag: "B954801-fgaqshivop",
      type: "DEBIT",
      account: "78342516",
      createdTime: "15-12-2024 17:12",
      tagValidity: "15-12-2024 19:12",
      movement: 5, // 2 days, 2 hours, 2 seconds
      withdrawalTried: "12",
      status: "Inactive",
      amount: "₹3,50,000",
    },
    {
      id: 3,
      tag: "HJ5651-45gs-sfehp",
      type: "CREDIT",
      account: "64536234",
      createdTime: "16-12-2024 4:15",
      tagValidity: "16-12-2024 7:15",
      movement: 7, // 1 day, 1 second
      withdrawalTried: "15",
      status: "Fraud",
      amount: "₹80,000",
    },
    {
      id: 4,
      tag: "lk12-zxcmk-89456",
      type: "CREDIT",
      account: "89213253",
      createdTime: "16-12-2024 4:15",
      tagValidity: "15-12-2024 7:15",
      movement: 12, // 3 minutes
      withdrawalTried: "9",
      status: "Active",
      amount: "₹1,80,000",
    },
  ]);
  const [muleAccounts, setMuleAccounts] = useState([
    {
      sNo: 1,
      accountNumber: "546875447",
      muleDetectionDate: "14-12-2024",
      reason: "Unusual login attempts from various IPS in short period",
      riskscore: "89%",
    },
    {
      sNo: 2,
      accountNumber: "986756434",
      muleDetectionDate: "12-12-2024",
      reason: "Multiple MFA failures",
      riskscore: "95%",
    },
    {
      sNo: 3,
      accountNumber: "768550082",
      muleDetectionDate: "10-12-2024",
      reason: "Use only for High Value Transactions",
      riskscore: "78%",
    },
  ]);
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleCloses = (event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      return;
    }
  };
  const navigate = useNavigate(); // Initialize useNavigate hook

  const handleLogout = () => {
    // Clear login status from localStorage
    localStorage.removeItem("isLoggedIn");

    // Notify other tabs about logout
    localStorage.setItem("logout-event", Date.now());

    // Redirect to LoginPage (forces reload in all tabs)
    window.location.href = "/";
  };

  const [selectedTag, setSelectedTag] = useState(null);
  const handlePanicClick = (tagId) => { };

  const handleReleaseClick = (tagId) => { };

  const formatMovement = (seconds) => {
    const days = Math.floor(seconds / (24 * 3600));
    const hours = Math.floor((seconds % (24 * 3600)) / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    return ` ${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };
  const handleOpen = () => {
    setOpen(true);
  };
  const handleMapClick = (tagId) => {
    if (tagId === 1) {
      // Open modal only for the first row (tagId === 1)
      setSelectedTag(tagId);
      setOpen(true);
    }
  };
  return (
    <div className="page-container">
      {/* Top Containers */}
      <div className={styles.mainContent}>
        <div className={styles.containerTiles}>
          <div className={styles.tile}>
            <h3 className={styles.tileTitle}>Total Tags</h3>
            <p className={styles.tileValue}>1000</p>
          </div>
          <div className={styles.tile}>
            <h3 className={styles.tileTitle}>Active Tags</h3>
            <p className={styles.tileValue}>820</p>
          </div>
          <div className={styles.tile}>
            <h3 className={styles.tileTitle}>Fraud Reported Tags</h3>
            <p className={styles.tileValue}>80</p>
          </div>
          <div className={styles.tile}>
            <h3 className={styles.tileTitle}>Flagged Mule Accounts</h3>
            <p className={styles.tileValue}>100</p>
          </div>
        </div>
      </div>
      <h2 className={styles.tableHeading}>Flagged Mule Accounts</h2>
      <div className={styles.adminListContainer}>
        <table className={styles.muleTable}>
          <thead>
            <tr>
              <th>S.No</th>
              <th>Account Number</th>
              <th>Mule Detection Date</th>
              <th>Reason</th>
              <th>Risk score</th>
            </tr>
          </thead>
          <tbody>
            {muleAccounts.map((tag) => (
              <tr key={tag.id}>
                <td>{tag.sNo}</td>
                <td>{tag.accountNumber}</td>
                <td>{tag.muleDetectionDate}</td>
                <td>{tag.reason}</td>
                <td className={styles.speedometerCell}>
                  <div className={styles.speedometerContainer}>
                    <img
                      src={
                        tag.riskscore >= "90%"
                          ? Image95 // Use Image95 for high risk score
                          : tag.riskscore >= "80%"
                            ? Image89 // Use Image89 for medium risk score
                            : Image78 // Use Image78 for low risk score
                      }
                      alt={`${tag.riskscore} speedometer`}
                      className={styles.speedometerImage}
                      style={{ width: "30%", height: "10%" }} // Set width and height
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Table */}
      <h2 className={styles.tableHeadings}>Tagged Transactions</h2>
      <div className={styles.adminListContainers}>
        <table className={styles.adminTable}>
          <thead>
            <tr>
              <th>Tag</th>
              <th>Type</th>
              <th>Account</th>
              <th>Amount</th>
              <th>Created Time</th>
              <th>Validity</th>
              <th>Movement</th>
              <th>
                Withdrawal <br />
                Tried
              </th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {tags.map((tag) => (
              <tr key={tag.id}>
                <td>{tag.tag}</td>
                <td>{tag.type}</td>
                <td>{tag.account}</td>
                <td>{tag.amount}</td>
                <td>{tag.createdTime}</td>
                <td>{tag.tagValidity}</td>
                <td>{tag.movement}</td> {/* Convert movement */}
                <td>{tag.withdrawalTried}</td>
                <td>
                  <span
                    style={{
                      color: tag.status === "Fraud" ? "red" : "inherit",
                    }}>
                    {tag.status}
                  </span>
                </td>
                <td className={styles.actionButtons}>
                  <button
                    className={styles.panicButton}
                    onClick={() => handlePanicClick(tag.id)}>
                    BLOCK
                  </button>
                  <button
                    className={styles.releaseButton}
                    onClick={() => handleReleaseClick(tag.id)}>
                    RELEASE
                  </button>
                  <img
                    src={map} // Replace with the actual path to your image
                    alt="Click to view India map"
                    onClick={() => handleMapClick(tag.id)}
                    style={{
                      cursor: "pointer",
                      marginLeft: "10px",
                      marginTop: "10px",
                      width: "30px", // Set desired width
                      height: "auto", // Maintain aspect ratio
                    }}
                  />
                  <Dialog
                    open={open && selectedTag === 1}
                    onClose={handleCloses}
                    fullWidth
                    maxWidth="lg" // Adjust the size of the modal
                    PaperProps={{
                      style: {
                        margin: "0", // Remove any default margin
                        maxWidth: "550px", // Set desired width
                        marginLeft: "670px", // Align to the right of the page
                        height: "100%", // Optional: full height for a sidebar effect
                        height: "100vh", // Full height of the viewport
                        width: "550px", // Fixed width
                      },
                    }}>
                    <DialogTitle>
                      P23-ywn-46fer-78912
                      <CloseIcon
                        onClick={handleClose}
                        style={{
                          cursor: "pointer",
                          position: "absolute",
                          top: "10px",
                          right: "10px",
                        }}
                      />
                    </DialogTitle>
                    <DialogContent
                      style={{
                        padding: "0",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                      }}>
                      <IndiaMap /> {/* Display the IndiaMap component here */}
                    </DialogContent>
                  </Dialog>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <button className="logout-btn" onClick={handleLogout}>
        Logout
      </button>
    </div>
  );
};

export default Dashboardnew;
